var _style, _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgHideEye = function SvgHideEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HideEye_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".HideEye_svg__st1{fill:currentColor}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HideEye_svg__Stroke",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HideEye_svg__Stroke-Copy",
    d: "M30 0c16.6 0 30 13.4 30 30S46.6 60 30 60 0 46.6 0 30 13.4 0 30 0z",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "HideEye_svg__st1",
    d: "M53.3 31.3c-.3-.5-9.6-11.8-21.3-11.8S11 30.8 10.7 31.3l-.6.7.6.7c.3.5 9.6 11.8 21.3 11.8s21-11.3 21.3-11.8l.6-.7-.6-.7zM32 42.2c-9 0-16.8-7.8-18.9-10.2C15.2 29.6 23 21.8 32 21.8S48.8 29.6 50.9 32C48.8 34.4 41 42.2 32 42.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "HideEye_svg__st1",
    d: "M32 23.4c-4.8 0-8.6 3.9-8.6 8.6s3.9 8.6 8.6 8.6 8.6-3.9 8.6-8.6-3.8-8.6-8.6-8.6zm0 15c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.9 6.4-6.4 6.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "HideEye_svg__st1",
    d: "M32 28.8c-1.8 0-3.2 1.4-3.2 3.2 0 1.8 1.4 3.2 3.2 3.2 1.8 0 3.2-1.4 3.2-3.2s-1.4-3.2-3.2-3.2zm0 4.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "HideEye_svg__st1",
    d: "M19.2 45.5c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l25.1-25.1c.4-.4 1-.4 1.4 0s.4 1 0 1.4L19.9 45.2c-.2.2-.4.3-.7.3z"
  })));
};
export default SvgHideEye;